import React, { useEffect, useState } from "react";
import Logo from "../assets/LogoBig.svg";
import SideBarItem from "./SideBarItem";
import { useTranslation } from "react-i18next";
import { matchPath } from "react-router";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMediaQuery } from "react-responsive";
import { faHome, faCog, faTimes, faBox } from "@fortawesome/free-solid-svg-icons";
import Fire from "../api/Fire";

const LeftSideBar = (props) => {
  const { t } = useTranslation();
  const [ads, setAds] = useState([]);
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  useEffect(() => {
    if (!isMobile) {
      (async () => {
        const result = await Fire._getAds();
        setAds((prev) => result);
      })();
    }

    return () => {
      setAds([]);
    };
  }, []);

  /* Set the width of the side navigation to 0 */
  const closeNav = () => {
    document.getElementById(t("language") === "en" ? "menu" : "menu-en").style.width = "0px";
    document.getElementById(t("language") === "en" ? "menu" : "menu-en").style.paddingInline = "0";
  };

  return (
    <div style={{ overflowY: "auto" }}>
      <div className="d-flex justify-content-between align-items-center">
        <img src={Logo} alt="brand" className="img-fluid" height={100} width={100} />
        <FontAwesomeIcon
          icon={faTimes}
          size="2x"
          color="#000"
          className="hoverable mx-4 drawerButtonClose"
          onClick={closeNav}
        />
      </div>

      <hr className="text-muted" />

      <SideBarItem
        title={t("home")}
        icon={faHome}
        onClick={() => {
          props.history.push({ pathname: "/" });
          closeNav();
        }}
        active={!!matchPath(props.location.pathname, { path: "/", exact: true })}
      />

      <SideBarItem
        title={t("orders")}
        icon={faBox}
        onClick={() => {
          props.history.push({ pathname: "/orders" });
          closeNav();
        }}
        active={!!matchPath(props.location.pathname, { path: "/orders" })}
      />

      <SideBarItem
        title={t("settings")}
        icon={faCog}
        onClick={() => {
          props.history.push({ pathname: "/settings" });
          closeNav();
        }}
        active={
          !!matchPath(props.location.pathname, {
            path: "/settings",
            exact: true,
          })
        }
      />

      {/* Render Ads */}
      {ads.length > 0 && !isMobile ? (
        <div className="text-center mt-5">
          <hr />
          <div>{t("ads")}</div>
          {ads.map((ad, i) => (
            <img
              key={i}
              style={{ cursor: "pointer", marginTop: "5px" }}
              src={ad.image}
              alt={i}
              height={100}
              width={200}
              onClick={() => window.open(ad.url, "_blank")}
            />
          ))}
        </div>
      ) : null}
      {/* Render Ads */}
    </div>
  );
};

export default withRouter(LeftSideBar);
